import React from "react";
import { useTranslation } from "react-i18next";

function TraditionSection() {
  const { t } = useTranslation();
  return (
    <section
      className="relative z-10 bg-slate-50/50 pb-14 pt-12 transition-colors dark:bg-slate-900 md:pb-16 md:pt-14"
      id="tradition-section"
      aria-labelledby="taolu-tradition-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="taolu-tradition-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("taolu_tradition.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
        </header>

        <article className="mx-auto max-w-3xl overflow-hidden rounded-2xl border border-slate-200 border-l-4 border-l-primary bg-white shadow-sm transition-all dark:border-slate-700 dark:border-l-primary-light dark:bg-slate-800 motion-safe:hover:shadow-md">
          <div className="relative px-5 py-8 pl-5 pr-[4.5rem] sm:px-8 sm:py-10 sm:pl-8 sm:pr-[5.5rem] md:px-10 md:py-12 md:pr-[6.5rem]">
            <span
              className="pointer-events-none absolute right-3 top-3 select-none font-serif text-6xl leading-none text-primary/[0.06] dark:text-primary-light/[0.08] sm:right-5 sm:top-4 sm:text-7xl md:text-8xl"
              aria-hidden
            >
              &ldquo;
            </span>
            <div className="relative z-[1] flex flex-col gap-5 sm:flex-row sm:items-start sm:gap-6">
              <div
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 dark:bg-primary-light/15 sm:h-14 sm:w-14"
                aria-hidden
              >
                <i className="fas fa-quote-left text-xl text-primary dark:text-primary-light sm:text-2xl" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="sr-only">{t("taolu_tradition.quote_aria")}</h3>
                <blockquote className="border-0 p-0">
                  <p className="text-pretty text-xl font-semibold leading-snug tracking-tight text-slate-900 dark:text-slate-100 sm:text-2xl md:text-3xl">
                    {t("taolu_tradition.quote")}
                  </p>
                </blockquote>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-200 bg-slate-50/90 px-5 py-6 dark:border-slate-700 dark:bg-slate-900/40 sm:px-8 sm:py-8 md:px-10 md:py-9">
            <h3 className="sr-only">{t("taolu_tradition.body_aria")}</h3>
            <p className="text-pretty text-base leading-relaxed text-slate-600 dark:text-slate-400 md:text-lg">
              {t("taolu_tradition.text")}
            </p>
          </div>
        </article>
      </div>
    </section>
  );
}

export default TraditionSection;
